import { render, staticRenderFns } from "./DctfWebsEmpresa.vue?vue&type=template&id=4fff2edd&"
import script from "./DctfWebsEmpresa.vue?vue&type=script&lang=js&"
export * from "./DctfWebsEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./DctfWebsEmpresa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports